module.exports = __webpack_public_path__ + "static/img/rank_gift_bg.fc814ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_gift_bg.png
// module id = pGFZ
// module chunks = 0